import React, { useState, useEffect } from "react";

function ApplyForm() {
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [duration, setDuration] = useState("");
  const [stream, setStream] = useState("");
  const [formWidth, setFormWidth] = useState("50%"); // Default width

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) {
        setFormWidth("90%");
      } else {
        setFormWidth("50%");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      name,
      lastName,
      email,
      phone,
      duration,
      stream,
    };

    localStorage.setItem("applicationData", JSON.stringify(formData));

    setName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setDuration("");
    setStream("");

    alert("Your Application Submitted!");
  };

  return (
    <>
     <style>
   {`
        form {
          display: flex;
          flex-direction: column;
          width: 50%;
          color: yellowgreen;
          margin: 0 auto;
          font-weight: 500;
          border: 0.3125rem inset greenyellow;
          padding: 0.625rem 1.25rem;
          font-size: 1rem; /* Default font size */
        }

        form input,
        select {
          color: yellowgreen;
          border: 0.125rem solid yellowgreen;
          outline: none;
          margin: 0.625rem 0;
          font-weight: 500;
          padding: 0.3125rem 0.9375rem;
          border-radius: 5rem;
          background-color: transparent;
        }

        @media (max-width: 576px) {
          form {
            width: 90%;
            font-size: 0.875rem; /* Decreased font size for small screens */
          }
        }
    `}
   </style>



   <form onSubmit={handleSubmit} style={{ width: formWidth, margin: "0 auto" }} >
        <h2 className="text-center" style={{ color: "yellowgreen" }} id="form">
          Registration
        </h2>
        <input
          type="text"
          placeholder="Enter Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Enter Your Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Enter Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="tel"
          placeholder="Enter Your Phone No."
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
        <label>Duration</label>
        <sup>*</sup>
        <select
          className="ms-3"
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
          required
        >
          <option>45 Days</option>
          <option>6 Months</option>
        </select>
        <label>Choose Stream</label>
        <sup>*</sup>
        <select
          className="ms-3"
          value={stream}
          onChange={(e) => setStream(e.target.value)}
          required
        >
          <option>Embedded Software Development</option>
          <option>Full Stack Development</option>
          <option>React Native</option>
          <option>AI & ML using Python</option>
        </select>
        <div className="text-center my-4">
          <button className="bttn submit_btn" style={{ backgroundColor: "yellowgreen" }}>
            Submit
          </button>
        </div>
      </form>
   
     
    </>
  );
}

export default ApplyForm;
